export default {
    venues() {
        return axios.get("/api/ecommerce/store/venues");
    },
    productvenues() {
        return axios.get("/api/ecommerce/store/productvenues");
    },
    categories(orig) {
        return axios.get("/api/ecommerce/store/categories?orig="+orig);
    },
    products(orig) {
        return axios.get("/api/ecommerce/store/products?orig="+orig);
    },
    payshopping(data) {
        return axios.post("/api/ecommerce/store/payshopping", data);
    },
    checkattendee(attendee) {
        return axios.post("/api/ecommerce/store/checkattendee", { attendee });
    },
    payshoppingcart(data) {
        return axios.post("/api/ecommerce/store/payshoppingcart", data);
    },
};
